import { render, staticRenderFns } from "./ParishHistory.vue?vue&type=template&id=6e3c75b3&"
import script from "./ParishHistory.vue?vue&type=script&lang=js&"
export * from "./ParishHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports